import PropTypes from 'prop-types';
import React, { Component } from 'react';

/**
 * Error Boundary for Theme Provider
 *
 * Catches errors in theme loading/switching to prevent app crashes.
 * Falls back to legacy theme on error.
 */
class ThemeErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console in development
    if (process.env.NODE_ENV !== 'production') {
      console.error('ThemeProviderWrapper Error:', error);
      console.error('Error Info:', errorInfo);
    }

    // Store error details for potential reporting
    this.setState({
      error,
      errorInfo,
    });

    // In production, you might want to send this to an error reporting service
    // Example: Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    const { hasError } = this.state;
    const { children, fallback } = this.props;

    if (hasError) {
      // Render fallback UI or just the children without theme wrapper
      return fallback || children;
    }

    return children;
  }
}

ThemeErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};

ThemeErrorBoundary.defaultProps = {
  fallback: null,
};

export default ThemeErrorBoundary;
